import { PlatformManager } from '../abstract/PlatformManager';
import { SaveDataKeys, SaveDataKeysDefaults } from '../SaveDataKeys';
import { SettingsSaveData } from '../SettingsManager';
import { addSignal } from '../../../utils/EventUtils';
import { Events } from '../../Events';

export class GDManager extends PlatformManager {
    private adSDKReady: boolean = false;

    public async setLoadingProgress(progress: number): Promise<void> {
        return new Promise<void>((resolve: () => any, reject: () => any): any => {
            resolve();
        });
    }

    public startGameAsync(): Promise<void> {
        return new Promise((resolve: () => any, reject: () => any): any => {
            resolve();
        });
    }

    public initializeAsync(): Promise<void> {
        addSignal(this, Events.AD_SDK_MANAGER_READY, () => {
            this.adSDKReady = true;
        });

        return new Promise((resolve: () => any, reject: () => any): any => {
            resolve();
        });
    }

    public saveData(key: SaveDataKeys, value: any): void {
        this.setCookie(key, value);
    }

    public getSaveData(keys: SaveDataKeys | SaveDataKeys[]): Promise<any> {
        let keySet: string[] = [];
        const result: {} = {};

        if (Array.isArray(keys)) {
            keySet = keys;
        } else {
            keySet.push(keys);
        }
        keySet.forEach((key: SaveDataKeys): void => {
            const cookieData: string = this.getCookie(key);
            let value: any;
            if (cookieData !== '') {
                // read data
                value = cookieData;
                if (this.onlyNumbers(value)) {
                    value = parseInt(value, 10);
                }
            } else {
                value = SaveDataKeysDefaults[key];
            }
            result[key] = value;
        });

        return new Promise<number>((resolve: any): any => {
            resolve(result);
            // return numberOfSessions;
        });
    }

    public async retreiveNumberOfSessions(): Promise<number> {
        let numberOfSessions: number = 0;
        const cookieData: string = this.getCookie(SaveDataKeys.numberOfSessions);
        if (cookieData !== '') {
            // read data
            numberOfSessions = parseInt(cookieData, 10);
        }
        return new Promise<number>((resolve: any): any => {
            resolve({numberOfSessions: numberOfSessions});
            // return numberOfSessions;
        });
    }

    public retrieveSettings(): Promise<SettingsSaveData> {
        return this.getSaveData([SaveDataKeys.settingsMusic, SaveDataKeys.settingsSFX, SaveDataKeys.settingsVibrate]);
    }

    private setCookie(name: string, value: any, exp_days: number = 1000): void {
        const d: Date = new Date();
        d.setTime(d.getTime() + (exp_days * 24 * 60 * 60 * 1000));
        const expires: string = 'expires=Wed, 13 Jan 2028 12:00:00 UTC';
        document.cookie = name + '=' + value + ';' + expires + ';path=/';
    }

    private getCookie(name: string): string {
        const cname: string = name + '=';
        const decodedCookie: string = decodeURIComponent(document.cookie);
        const ca: string[] = decodedCookie.split(';');
        for (let i: number = 0; i < ca.length; i++) {
            let c: string = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(cname) === 0) {
                return c.substring(cname.length, c.length);
            }
        }
        return '';
    }

    private onlyNumbers(str: string): boolean {
        return /^[0-9]+$/.test(str);
    }

    public isAdSDKReady(): boolean {
        return this.adSDKReady;
    }
}